import { BindTypeField, ConfigField } from '@gantt/components/GanttCreateOrEdit'

import { parseRsqlFields } from './parseRsqlFields'

const skip = ['additionalFields', 'actions', 'pathStr', 'pathArray']
const filterKeys = ['filter', 'timeEdgesFilter'] as const

export const getAvailableVariablesObject = (timelineData: Record<string, any>) => {
  const availableVariablesObject: Record<string, ConfigField> = {}

  function getAvailableVariables(item: Record<string, any>) {
    for (const property in item) {
      if (!skip.includes(property)) {
        if (item[property]?.field?.pathStr) {
          availableVariablesObject[item[property].field.field] = item[property].field
        } else if (item[property]?.field_array?.length) {
          item[property]?.field_array?.map((item: ConfigField) => {
            availableVariablesObject[item?.field] = item
          })
        } else {
          if (Array.isArray(item[property])) {
            item[property].map((item: BindTypeField) => {
              getAvailableVariables(item)
            })
          }

          if (item[property] instanceof Object) {
            getAvailableVariables(item[property])
          }
        }
      }
    }
  }

  getAvailableVariables(timelineData)

  for (const key of filterKeys) {
    const rsql: string = timelineData[key]?.static ?? ''
    for (const systemField of parseRsqlFields(rsql)) {
      // user-defined variable with the same name takes priority
      if (!availableVariablesObject[systemField.field]) {
        availableVariablesObject[systemField.field] = systemField
      }
    }
  }

  return availableVariablesObject
}
